import React from 'react';
import { SelectArrow, TickMarkCircle, TickMarkBlankCircle } from './Icons';


const ToggleFilter = (props) => {

  const {
          filterOpen,
          filterTitle,
          filterName,
          handleFilter,
          setHeatmapLayerActive,
          heatmapLayerActive,
          buildingTypeActive,
          setBuildingTypeActive,
          setBoundaryLayerActive,
          boundaryLayerActive
        } = props;



  const sumOfActive = () => {
    let a = 0;
    let b = 0;
    if (heatmapLayerActive || buildingTypeActive) {
      a++;
    }
    if (boundaryLayerActive) {
      b++;
    }
    return a + b;
  }

  return (
    <div className={`filter-tab ${(filterOpen===filterName) ? 'expanded' : 'closed' }`}>
      <div className='filter-expander' id={filterName} onClick={(e) => handleFilter(e)}>
        <div>
          <h2 className='color-invert'>{ filterTitle }</h2>
            <p className='color-invert'>{(sumOfActive() === 0) ? 'None Selected' : sumOfActive()+ ' Selected' }</p>
        </div>
        <SelectArrow className={(filterOpen===filterName) ?  'arrow' : 'arrow-spin-90' }/>
      </div>
      <div className='filter-list'>
        <div className='filter-select-all flex-container-left' onClick={() => setHeatmapLayerActive(!heatmapLayerActive)}>
          { heatmapLayerActive && <TickMarkCircle className='inline-style'/> }
          { !heatmapLayerActive && <TickMarkBlankCircle className='inline-style'/> }

          <p className='color-invert inline-style'>Heatmap</p>
        </div>

        {/* <div className='filter-select-all flex-container-left' onClick={() => setBuildingTypeActive(!buildingTypeActive)}>
          { buildingTypeActive && <TickMarkCircle className='inline-style'/> }
          { !buildingTypeActive && <TickMarkBlankCircle className='inline-style'/> }

          <p className='color-invert inline-style'>Heatmap</p>
        </div> */}

        <div className='filter-select-all flex-container-left' onClick={() => setBoundaryLayerActive(!boundaryLayerActive)}>
          { boundaryLayerActive && <TickMarkCircle className='inline-style'/> }
          { !boundaryLayerActive && <TickMarkBlankCircle className='inline-style'/> }

          <p className='color-invert inline-style'>Local Authority Boundaries</p>
        </div>

      </div>
    </div>
  )
}

export default ToggleFilter;
